import { useEffect, useRef } from "react";

interface EmailPreviewProps {
  html: string;
  className?: string;
}

export function EmailPreview({ html, className = "" }: EmailPreviewProps) {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    if (iframeRef.current) {
      const doc = iframeRef.current.contentDocument;
      if (doc) {
        doc.open();
        doc.write(html);
        doc.close();
      }
    }
  }, [html]);

  return (
    <iframe
      ref={iframeRef}
      title="Email Preview"
      className={`w-full border border-slate-core rounded-lg bg-white ${className}`}
      style={{ minHeight: "600px" }}
    />
  );
}
